import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=45224afa&scoped=true"
import script from "./DashboardWidget.vue?vue&type=script&lang=js"
export * from "./DashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=45224afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45224afa",
  null
  
)

export default component.exports